export default "__VITE_ASSET__CypoF1mX__"